import { render } from "./Det.vue?vue&type=template&id=2339c988"
import script from "./Det.vue?vue&type=script&lang=js"
export * from "./Det.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/sbimh.nl/tickets.sbimh.nl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__